import { Link } from 'react-router-dom';
import { siteConfig, categories, articles } from '@/mocks/data';

export default function Footer() {
  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <div className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg">
                  <i className="ri-shield-check-line text-lg"></i>
                </div>
                <span className="text-lg font-semibold font-heading whitespace-nowrap text-background-50">
                  {siteConfig.name}
                </span>
              </Link>
              <p className="text-sm text-foreground-400 leading-relaxed mb-4">
                安全、合规、私密的成人免费网站资源导航平台。帮助成年用户高效找到正规资源，拒绝风险链接，保障隐私安全。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">资源分类</h4>
              <ul className="space-y-2">
                {categories.slice(0, 5).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">精选文章</h4>
              <ul className="space-y-2">
                {articles.slice(0, 5).map((article) => (
                  <li key={article.id}>
                    <Link
                      to={`/article/${article.id}`}
                      className="text-sm text-foreground-400 hover:text-primary-400 transition-colors line-clamp-1"
                    >
                      {article.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">联系我们</h4>
              <ul className="space-y-2 text-sm text-foreground-400">
                <li className="flex items-start gap-2">
                  <i className="ri-mail-line mt-0.5 text-foreground-500"></i>
                  <span>{siteConfig.brand.contact.email}</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-phone-line mt-0.5 text-foreground-500"></i>
                  <span>{siteConfig.brand.contact.phone}</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-map-pin-line mt-0.5 text-foreground-500"></i>
                  <span>{siteConfig.brand.contact.address}</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} {siteConfig.name} 版权所有 | 本站仅提供资源导航，不存储任何内容
            </p>
            <div className="flex items-center gap-4 text-xs text-foreground-500">
              <Link to="/about" className="hover:text-primary-400 transition-colors whitespace-nowrap">
                关于我们
              </Link>
              <span className="text-foreground-700">|</span>
              <Link to="/" className="hover:text-primary-400 transition-colors whitespace-nowrap">
                免责声明
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}